import React from "react";
import modalStyles from "@/styles/Modal.module.scss";
import { Button } from "../Buttons";
import Link from "next/link";
import routes from "@/lib/routes";

const GuidelineAgreementModal = (props) => {
  return (
    <div className={modalStyles.container}>
      <header>
        <h2>コメント投稿時の留意点</h2>
      </header>
      <p className={modalStyles.guideLineText}>
        ご利用にあたっては
        <Link
          className={modalStyles.linkText}
          href="/static/legal/chat_guideline/"
          target="_blank"
          rel="noopener noreferrer"
        >
          コミュニティガイドライン
        </Link>
        に同意の上ご利用ください。
      </p>
      <Button
        fillWhiteColor
        fontFixed
        large
        fontBold
        onClick={props.handleClick}
      >
        同意の上で参加する
      </Button>
      <Button
        fontFixed
        large
        onClick={props.modalAndComponentCloseHandle}
        borderLight
      >
        閉じる
      </Button>
    </div>
  );
};

export default GuidelineAgreementModal;
